// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2KOY-","itemTitle":"ClientEmergencyInfo_itemTitle__2khf2","itemText":"ClientEmergencyInfo_itemText__1z6g7"};